import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/components/logo.css';

/**
 * Composant FallbackImages mémoïsé pour éviter les re-renders inutiles
 * et les rechargements d'images lors de changements d'état non liés
 */
const FallbackImages = React.memo(({ isDarkMode }) => {
  if (isDarkMode) {
    return (
      <picture>
        <source srcSet="/images/webp/MPTlogo-dark.webp" type="image/webp" />
        <source srcSet="/images/MPTlogo-dark.png" type="image/png" />
        <img
          src="/images/MPTlogo-dark.png"
          alt="Magic Park Times Logo"
          className="logo logo-dark"
          width="800"
          height="259"
          fetchpriority="high"
          loading="eager"
          decoding="sync"
        />
      </picture>
    );
  }

  return (
    <picture>
      <source srcSet="/images/webp/MPTlogo.webp" type="image/webp" />
      <source srcSet="/images/MPTlogo.png" type="image/png" />
      <img
        src="/images/MPTlogo.png"
        alt="Magic Park Times Logo"
        className="logo logo-light"
        width="800"
        height="259"
        fetchpriority="high"
        loading="eager"
        decoding="sync"
      />
    </picture>
  );
});

FallbackImages.displayName = 'FallbackImages';

/**
 * Composant HeaderLogo qui gère l'affichage du logo ou de la vidéo
 * selon la qualité de la connexion et le support du navigateur.
 * 
 * Caractéristiques :
 * - Affiche une vidéo WebM/MP4 si connexion rapide (4G/WiFi)
 * - Fallback sur l'image standard si connexion lente ou mode économie de données
 * - Support du mode sombre/clair pour l'image de fallback
 * - Respect des dimensions et du ratio du logo original
 */
const HeaderLogo = ({ isDarkMode }) => {
  return (
    <div className="logo-container">
      <Link to="/">
        <>
          {/*
          // Vidéo d'hiver MPT_Winter (temporairement désactivée)
          // Pour réactiver au prochain hiver :
          // 1. Décommenter ce bloc <video>...</video>
          // 2. Remettre la logique canPlayVideo / useEffect (state, listeners réseau)
          // 3. Réimporter checkNetworkQuality et onConnectionChange
          // 4. Modifier le return pour utiliser {canPlayVideo ? video : fallback}
          <div className="video-logo-wrapper" style={{ position: 'relative', width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', background: 'transparent' }}>
            <video
              autoPlay
              loop
              muted
              playsInline
              className="logo video-logo"
              poster={isDarkMode ? "/images/MPTlogo-dark.png" : "/images/MPTlogo.png"}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'contain', // Affiche la vidéo entière sans cropper
                maxWidth: '549px',
                maxHeight: '178px',
                aspectRatio: '16 / 9' // Force le ratio vidéo si nécessaire, ou laisser auto
              }}
            >
              <source src="/videos/MPT_Winter.webm" type="video/webm" />
              <source src="/videos/MPT_Winter.mp4" type="video/mp4" />
              <img src={isDarkMode ? "/images/MPTlogo-dark.png" : "/images/MPTlogo.png"} alt="Magic Park Times Logo" width="800" height="259" />
            </video>
          </div>
          */}
          <FallbackImages isDarkMode={isDarkMode} />
        </>
      </Link>
    </div>
  );
};

// Mémoïsation du composant pour éviter les re-renders inutiles
export default React.memo(HeaderLogo);
